// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* form */

.form {
    width: 90vw;
    max-width: var(--fixed-width);
    background: var(--white);
    border-radius: var(--borderRadius);
    box-shadow: var(--shadow-2);
    padding: 2rem 2.5rem;
    margin: 3rem auto;
  }
  .form-label {
    display: block;
    /* font-size: var(--small-text); */
    font-size: large;
    margin-bottom: 0.5rem;
    text-transform: capitalize;
    letter-spacing: var(--letterSpacing);
  }
  
  .form-input,
  .form-textarea {
    width: 100%;
    padding: 0.375rem 0.75rem;
    border-radius: var(--borderRadius);
    background: var(--backgroundColor);
    border: 1px solid var(--grey-200);
  }
  
  .form-row {
    margin-bottom: 1rem;
  }
  
  .form-textarea {
    height: 7rem;
  }
  ::placeholder {
    font-family: inherit;
    color: var(--grey-400);
  }
  .form-alert {
    color: var(--red-dark);
    letter-spacing: var(--letterSpacing);
    text-transform: capitalize;
  }
  /* extra styles */
  .form .form-label {
    text-align: left;
    /* margin-bottom: 10px; */
    color: hsl(185, 57%, 50%);
    font-size: large;
  }
  .form .btn-block {
    margin-top: 0.5rem;
  }
  
  .li-item {
    margin-bottom: 0.5rem; 
  }
  

  .role-selection-container {
    max-width: 500px;
    margin: 0 auto;
    padding: 2rem;
    border: 2px solid #ccc;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: hsl(184, 65%, 59%);
  }
  
  .role-selection-title {
    text-align: center;
    margin-bottom: 1.5rem;
    font-size: 1.5rem;
    color: #333;
  }
  
  .role-selection-option {
    margin-bottom: 1rem;
    padding: 0.5rem;
  }
  
  .role-label {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    color: #444;
  }
  
  .role-input {
    margin-right: 1rem;
    transform: scale(1.2);
    accent-color: #007bff;
  }
  
  .role-selection-button {
    display: block;
    width: 100%;
    padding: 0.75rem;
    font-size: 1.1rem;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .role-selection-button:hover {
    background-color: #0056b3;
  }

.summary-full-width {
  width: 100%;
  max-width: none !important;  /* Override max-width */
}

.section-center.page-info .summary-full-width {
  max-width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 10px;
}

.summary-form {
  background-color: #f9f9f9;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 1200px;
}

.form-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  text-align: center;
}

.summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr; 
  gap: 2rem;
  margin-bottom: 2rem;
}

.summary-grid.single-column {
  grid-template-columns: 1fr; 
}

.summary-section {
  background: #ffffff;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #ddd;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  flex: 1 1;
  min-width: 45%;
}


.summary-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.8rem;
  padding: 0.5rem;
  border-bottom: 1px solid #ddd;
  transition: background-color 0.3s ease;
}

.summary-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.label {
  font-weight: bold;
  color: #444;
}

.value {
  color: #333;
  font-style: italic;
}

.terms-container {
  background: #fefefe;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #ddd;
  margin: 1rem auto; 
  text-align: center; 
  max-width: 600px;  
  display: flex;
  flex-direction: column;
  align-items: center; 
}


.form-footer {
  display: flex;
  justify-content: center;  
  gap: 10px;  
  margin-top: 2rem;
  padding-top: 1rem; 
  border-top: 1px solid var(--clr-grey-3)
}



.summary-note {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.1rem;
  text-align: center;  
  display: block;      
}


/*Responsive Styles */
@media (max-width: 1024px) {
  .summary-form {
      padding: 1.5rem;
  }
  
  .summary-grid {
      gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .summary-grid {
      grid-template-columns: 1fr; 
      gap: 1rem;
  }

  .summary-section {
      min-width: 100%;
  }

  .form-footer {
      flex-direction: column;
      align-items: center;
  }

  .btn {
      width: 100%;
      margin-top: 10px;
  }
}


  /* .summary-form {
    background-color: #f9f9f9;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .form-title {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }
  
  .summary-container {
    background: var(--clr-primary-5);
    padding: 1.5rem;
    border-radius: 8px;
  }
  
  .summary-note {
    color: #333;
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }
  
  .section-title {
    font-size: 1.2rem;
    font-weight: bold;
    margin-top: 1.5rem;
    color: var(--clr-primary-1);
  }
  
  .summary-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  
  .summary-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.8rem;
    padding: 0.5rem;
    border-bottom: 1px solid #ddd;
    transition: background-color 0.3s ease;
  }
  
  .summary-item:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  
  .label {
    font-weight: bold;
    color: #444;
  }
  
  .value {
    color: #333;
    font-style: italic;
  }
  
  .toggle-btn {
    background: var(--clr-primary-9);
    color: var(--clr-primary-1);
    padding: 0.375rem 0.75rem;
    font-weight: 700;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    font-size: 0.875rem;
    border: 2px solid transparent;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    border-radius: var(--radius);

  }
  
  .toggle-btn:hover {
    text-decoration: underline;
  } */

  /* Header Styling */
.form-header {
  text-align: center; 
  font-size: 1.5rem; 
  color: var(--clr-primary-3); 
  margin-bottom: 1.5rem; 
}

.form-header-no-align {
  /* text-align: center;  */
  font-size: 1.5rem; 
  color: var(--clr-grey-1); 
  margin-bottom: 1.5rem; 
}
  /* BusinessDetailsForm Specific */
.business-details-form {
  max-width: 1200px; /* Expand form width */
  margin: 0 auto;
  padding: 2rem;
  background-color: #f9f9f9; /* Light background */
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.business-details-form .form-sections-container {
  display: flex;
  justify-content: space-between;
  gap: 20px; /* Space between sections */
  margin-bottom: 2rem;
}
.business-details-form .form-label {
  text-align: left;
  /* margin-bottom: 10px; */
  color: hsl(185, 57%, 50%);
}
.business-contact-section,
.business-address-section {
  flex: 1 1; /* Equal space for both sections */
  padding: 1.5rem;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); /* Subtle shadow */
}

.title-container-mid {
  text-align: center;
  margin-bottom: 1rem;
}

.title-mid {
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--clr-grey-3);
}

.required {
  color: red;
  font-weight: bold;
  margin-left: 0.2rem;
}

.required-two{
  color: red;
  font-weight: bold;
  margin-left: 0.2rem;
}

/* Error Text */
.error-text {
  color: red;
  font-size: 0.9rem;
  margin-top: 0.25rem;
  font-weight: bold;
}

.form-row .error-text {
  display: block;
}

/* Buttons for BusinessDetailsForm */
.business-details-form .form-navigation {
  display: flex;
  justify-content: center;
  gap: 20px; /* Space between buttons */
  margin-top: 20px;
}

.business-details-form .btn {
  /* padding: 10px 20px; */
  font-size: 1rem;
  /* border-radius: 5px; */
  cursor: pointer;
}

.business-details-form .btn-primary {
  background-color: #007bff;
  color: #fff;
}

.business-details-form .btn-secondary {
  background-color: #6c757d;
  color: #fff;
}

/* Responsive Design */
@media (max-width: 768px) {
  .business-details-form .form-sections-container {
      flex-direction: column; /* Stack sections vertically on smaller screens */
  }

  .business-contact-section,
  .business-address-section {
      min-width: 100%; /* Full width for smaller screens */
  }
}

/* 
  .business-address-section {
    margin-bottom: 2rem;
    padding: 1rem;
    border: 1px solid var(--clr-accent);
    border-radius: 8px;
  }
  
  .business-contact-section {
    margin-bottom: 2rem;
    padding: 1rem;
    border: 1px solid var(--clr-accent);
    border-radius: 8px;
  } */

  /* .title-container-mid {
    display: flex;
    justify-content: center; 
    align-items: center; 
    margin-bottom: 1rem; 
    height: 4rem; 
  }
  
  .title-mid {
    margin: 0;
    font-size: 1.25rem; 
    font-weight: 500;
    color: var(--clr-grey-3);
  }

   */
  
  .form-row .error-text {
    display: block; 
  }
  
  .calculator-wrapper_price_detail {
    /* background-color: var(--clr-primary-9); */
    border: 1px solid var(--clr-primary-4);
    border-radius: 0.75rem;
    padding: 2rem;
    margin-bottom: 2.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
  
  .calculator-wrapper_price_detail h3.form-header {
    color: var(--clr-primary-6);
    font-size: 1.4rem;
    margin-bottom: 0.5rem;
  }
  
  .calculator-note_price_detail {
    color: var(--red-dark);
    font-size: 0.95rem;
    margin-bottom: 1.5rem;
  }
  
  .counter_price_detail {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
  }
  
  .counter-btn_price_detail {
    background-color: var(--clr-primary-5);
    color: white;
    font-size: 1.25rem;
    width: 2.5rem;
    height: 2.5rem;
    border: none;
    border-radius: 0.5rem;
    margin: 0 1rem;
    transition: background-color 0.2s ease;
    cursor: pointer;
  }
  
  .counter-btn_price_detail:hover {
    background-color: var(--clr-primary-6);
  }
  
  .counter-value_price_detail {
    font-size: 1.5rem;
    font-weight: bold;
    color: var(--clr-primary-7);
    padding: 0 0.5rem;
  }
  
  .cost-breakdown_price_detail {
    /* background-color: var(--clr-grey-7); */
    border-radius: 0.5rem;
    padding: 1rem 1.5rem;
    color: var(--clr-grey-5);
    font-size: 1rem;
    line-height: 1.8;
  }
  
  .cost-breakdown_price_detail p {
    margin: 0.4rem 0;
    color: var(--clr-grey-1);
  }
  
  .total_price_detail {
    font-size: 1.15rem;
    font-weight: bold;
    color: var(--clr-primary-7);
    margin-top: 1rem;
  }
  
  .max-practitioners-info {
    background-color: var(--clr-primary-7);
    padding: 1rem 1.5rem;
    border-radius: var(--radius);
    color: var(--clr-grey-1);
    font-size: 1rem;
    margin-bottom: 2rem;
    text-align: center;
    font-weight: 500;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  }
  
  .phone-input-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .phone-prefix {
    width: 50px;
    padding: 0.5rem;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #f5f5f5;
    color: #555;
  }
  
  .phone-main-input {
    flex: 1 1;
  }
  
  .checkbox-row-pricing {
    margin: 1.5rem 0;
    display: flex;
    align-items: center;
  }
  
  .checkbox-label-pricing {
    font-weight: 350;
    display: flex;
    align-items: center;
    gap: 0.6rem;
    /* color: var(--clr-white); */
  }
  
  .value-added-section {
    margin-top: 2rem;
    border-top: 1px solid var(--clr-grey-4);
    padding-top: 1.5rem;
  }
  
  .value-added-title {
    font-size: 1.15rem;
    font-weight: 600;
    margin-bottom: 0.75rem;
    /* color: var(--clr-primary-4); */
  }
  
  .pricing-details-form {
    /* max-width: 1200px;
    width: 95%; */
    margin: 2rem auto;
    padding: 2rem;
    background: #f9f9f9;
    border-radius: var(--radius);
    box-shadow: var(--shadow-2);
  }
  
  .pricing-details-form-public {
    /* max-width: 1200px;
    width: 95%; */
    margin: 1rem;
    /* padding: 2rem; */
    border: 3px solid var(--clr-primary-3);
    /* background: #f9f9f9; */
    border-radius: var(--radius);
    box-shadow: var(--shadow-2);
  }

  .pricing-public-main-title {
    font-size: 2rem;
    font-weight: 700;
    margin-top: 1rem;
    margin-bottom: 2rem;
    text-align: center;
    color: var(--clr-primary-5);
  }
  
  .grid-layout-pricing {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  
  @media (max-width: 768px) {
    .grid-layout-pricing {
      grid-template-columns: 1fr;
    }
  }
  
  /* Section Titles */
  .section-title-pricing {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 1.2rem;
    color: var(--clr-primary-3);
  }
  
  /* Left Column */
  .left-column-pricing {
    padding: 1rem 1.5rem;
    background-color: var(--clr-white);
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
  }
  
  /* Right Column */
  .right-column-pricing {
    padding: 1rem 1.5rem;
    background-color: var(--clr-white);
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
  }
  
  /* One-Time Fee Box */
  .platform-fee-box {
    /* background-color: var(--clr-primary-9); */
    border: 1px solid var(--clr-primary-4);
    padding: 1rem 1.25rem;
    /* margin-top: 2rem; */
    margin-bottom: 0.25rem;
    border-radius: 0.75rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
  
  /* .platform-fee-box h4 {
    font-size: 1.1rem;
    color: var(--clr-primary-3);
    margin-bottom: 0.5rem;
  }
   */
  .platform-total {
    font-weight: 600;
    color: var(--clr-primary-6);
    margin-top: 0.75rem;
  }
  
  /* Feature Bullet List */
  .features-bullet-list {
    margin-top: 2rem;
  }
  
  .features-bullet-list h4 {
    font-size: 1.1rem;
    color: var(--clr-primary-4);
    margin-bottom: 0.5rem;
  }
  
  .features-bullet-list ul {
    padding-left: 1.5rem;
    list-style: disc;
    color: var(--clr-grey-2);
  }
  
  .features-bullet-list li {
    margin-bottom: 0.4rem;
    font-size: 0.95rem;
    line-height: 1.6;
  }
  
.input-and-addon-box,
.features-box {
  /* background-color: var(--clr-grey-7); */
  border-radius: var(--radius);
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: var(--shadow-1);
  border: 1px solid var(--clr-primary-4);
}

.features-box ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  color: var(--clr-grey-2);
}

.features-box li {
  margin-bottom: 1rem;
  font-size: 0.95rem;
  line-height: 1.6;
}

.pricing-navigation {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-top: 2.5rem;
  flex-wrap: wrap;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin-top: 1rem;
}

.feature-list li {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1rem;
  color: var(--clr-grey-2);
  padding: 0.1rem 0;
}

.feature-icon {
  font-size: 1rem;
  color: var(--clr-primary-5);
  flex-shrink: 0;
}

.feature-group {
  margin-bottom: 1.5rem;
}

.feature-group h5 {
  font-size: 1.05rem;
  color: var(--clr-primary-4);
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.boxed-section {
  border: 1px solid var(--clr-primary-4);
  border-radius: var(--radius);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  /* background-color: var(--clr-grey-9); */
}

.tax-note {
  font-size: 0.9rem;
  margin-top: 0.25rem;
  color: var(--clr-grey-6);
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/components/registration-multi-step-forms/form.css"],"names":[],"mappings":"AAAA,SAAS;;AAET;IACI,WAAW;IACX,6BAA6B;IAC7B,wBAAwB;IACxB,kCAAkC;IAClC,2BAA2B;IAC3B,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,kCAAkC;IAClC,gBAAgB;IAChB,qBAAqB;IACrB,0BAA0B;IAC1B,oCAAoC;EACtC;;EAEA;;IAEE,WAAW;IACX,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;IAClC,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,oCAAoC;IACpC,0BAA0B;EAC5B;EACA,iBAAiB;EACjB;IACE,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;;EAGA;IACE,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;EACE,WAAW;EACX,0BAA0B,GAAG,uBAAuB;AACtD;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;EACzC,SAAO;EACP,cAAc;AAChB;;;AAGA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB;AACF;;;;AAIA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;;AAGA,qBAAqB;AACrB;EACE;MACI,eAAe;EACnB;;EAEA;MACI,WAAW;EACf;AACF;;AAEA;EACE;MACI,0BAA0B;MAC1B,SAAS;EACb;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,sBAAsB;MACtB,mBAAmB;EACvB;;EAEA;MACI,WAAW;MACX,gBAAgB;EACpB;AACF;;;EAGE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA8EG;;EAEH,mBAAmB;AACrB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;AACvB;EACE,iCAAiC;AACnC;EACE,iBAAiB,EAAE,sBAAsB;EACzC,cAAc;EACd,aAAa;EACb,yBAAyB,EAAE,qBAAqB;EAChD,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS,EAAE,2BAA2B;EACtC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,SAAO,EAAE,kCAAkC;EAC3C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC,EAAE,kBAAkB;AAC/D;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS,EAAE,0BAA0B;EACrC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;MACI,sBAAsB,EAAE,iDAAiD;EAC7E;;EAEA;;MAEI,eAAe,EAAE,mCAAmC;EACxD;AACF;;AAEA;;;;;;;;;;;;;KAaK;;EAEH;;;;;;;;;;;;;;;IAeE;;EAEF;IACE,cAAc;EAChB;;EAEA;IACE,4CAA4C;IAC5C,sCAAsC;IACtC,sBAAsB;IACtB,aAAa;IACb,qBAAqB;IACrB,yCAAyC;EAC3C;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;IACtC,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,sCAAsC;IACtC,eAAe;EACjB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,yCAAyC;IACzC,qBAAqB;IACrB,oBAAoB;IACpB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,sCAAsC;IACtC,oBAAoB;IACpB,4BAA4B;IAC5B,wBAAwB;IACxB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,uCAAuC;IACvC,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE;iBACa;IACb,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE;iBACa;IACb,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;IACtC,yBAAyB;IACzB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE;MACE,0BAA0B;IAC5B;EACF;;EAEA,mBAAmB;EACnB;IACE,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA,gBAAgB;EAChB;IACE,oBAAoB;IACpB,kCAAkC;IAClC,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA,iBAAiB;EACjB;IACE,oBAAoB;IACpB,kCAAkC;IAClC,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA,qBAAqB;EACrB;IACE,4CAA4C;IAC5C,sCAAsC;IACtC,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,yCAAyC;EAC3C;;EAEA;;;;;IAKE;EACF;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA,wBAAwB;EACxB;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;EAClB;;AAEF;;EAEE,yCAAyC;EACzC,4BAA4B;EAC5B,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB","sourcesContent":["/* form */\n\n.form {\n    width: 90vw;\n    max-width: var(--fixed-width);\n    background: var(--white);\n    border-radius: var(--borderRadius);\n    box-shadow: var(--shadow-2);\n    padding: 2rem 2.5rem;\n    margin: 3rem auto;\n  }\n  .form-label {\n    display: block;\n    /* font-size: var(--small-text); */\n    font-size: large;\n    margin-bottom: 0.5rem;\n    text-transform: capitalize;\n    letter-spacing: var(--letterSpacing);\n  }\n  \n  .form-input,\n  .form-textarea {\n    width: 100%;\n    padding: 0.375rem 0.75rem;\n    border-radius: var(--borderRadius);\n    background: var(--backgroundColor);\n    border: 1px solid var(--grey-200);\n  }\n  \n  .form-row {\n    margin-bottom: 1rem;\n  }\n  \n  .form-textarea {\n    height: 7rem;\n  }\n  ::placeholder {\n    font-family: inherit;\n    color: var(--grey-400);\n  }\n  .form-alert {\n    color: var(--red-dark);\n    letter-spacing: var(--letterSpacing);\n    text-transform: capitalize;\n  }\n  /* extra styles */\n  .form .form-label {\n    text-align: left;\n    /* margin-bottom: 10px; */\n    color: hsl(185, 57%, 50%);\n    font-size: large;\n  }\n  .form .btn-block {\n    margin-top: 0.5rem;\n  }\n  \n  .li-item {\n    margin-bottom: 0.5rem; \n  }\n  \n\n  .role-selection-container {\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 2rem;\n    border: 2px solid #ccc;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    background-color: hsl(184, 65%, 59%);\n  }\n  \n  .role-selection-title {\n    text-align: center;\n    margin-bottom: 1.5rem;\n    font-size: 1.5rem;\n    color: #333;\n  }\n  \n  .role-selection-option {\n    margin-bottom: 1rem;\n    padding: 0.5rem;\n  }\n  \n  .role-label {\n    display: flex;\n    align-items: center;\n    font-size: 1.2rem;\n    color: #444;\n  }\n  \n  .role-input {\n    margin-right: 1rem;\n    transform: scale(1.2);\n    accent-color: #007bff;\n  }\n  \n  .role-selection-button {\n    display: block;\n    width: 100%;\n    padding: 0.75rem;\n    font-size: 1.1rem;\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .role-selection-button:hover {\n    background-color: #0056b3;\n  }\n\n.summary-full-width {\n  width: 100%;\n  max-width: none !important;  /* Override max-width */\n}\n\n.section-center.page-info .summary-full-width {\n  max-width: 100%;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  background: #fff;\n  border-radius: 10px;\n}\n\n.summary-form {\n  background-color: #f9f9f9;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  max-width: 1200px;\n}\n\n.form-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr; \n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.summary-grid.single-column {\n  grid-template-columns: 1fr; \n}\n\n.summary-section {\n  background: #ffffff;\n  padding: 1.5rem;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  flex: 1;\n  min-width: 45%;\n}\n\n\n.summary-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.summary-item {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.8rem;\n  padding: 0.5rem;\n  border-bottom: 1px solid #ddd;\n  transition: background-color 0.3s ease;\n}\n\n.summary-item:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.label {\n  font-weight: bold;\n  color: #444;\n}\n\n.value {\n  color: #333;\n  font-style: italic;\n}\n\n.terms-container {\n  background: #fefefe;\n  padding: 1.5rem;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  margin: 1rem auto; \n  text-align: center; \n  max-width: 600px;  \n  display: flex;\n  flex-direction: column;\n  align-items: center; \n}\n\n\n.form-footer {\n  display: flex;\n  justify-content: center;  \n  gap: 10px;  \n  margin-top: 2rem;\n  padding-top: 1rem; \n  border-top: 1px solid var(--clr-grey-3)\n}\n\n\n\n.summary-note {\n  color: #333;\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n  text-align: center;  \n  display: block;      \n}\n\n\n/*Responsive Styles */\n@media (max-width: 1024px) {\n  .summary-form {\n      padding: 1.5rem;\n  }\n  \n  .summary-grid {\n      gap: 1.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .summary-grid {\n      grid-template-columns: 1fr; \n      gap: 1rem;\n  }\n\n  .summary-section {\n      min-width: 100%;\n  }\n\n  .form-footer {\n      flex-direction: column;\n      align-items: center;\n  }\n\n  .btn {\n      width: 100%;\n      margin-top: 10px;\n  }\n}\n\n\n  /* .summary-form {\n    background-color: #f9f9f9;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .form-title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin-bottom: 1.5rem;\n  }\n  \n  .summary-container {\n    background: var(--clr-primary-5);\n    padding: 1.5rem;\n    border-radius: 8px;\n  }\n  \n  .summary-note {\n    color: #333;\n    margin-bottom: 1rem;\n    font-size: 1.1rem;\n  }\n  \n  .section-title {\n    font-size: 1.2rem;\n    font-weight: bold;\n    margin-top: 1.5rem;\n    color: var(--clr-primary-1);\n  }\n  \n  .summary-list {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .summary-item {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 0.8rem;\n    padding: 0.5rem;\n    border-bottom: 1px solid #ddd;\n    transition: background-color 0.3s ease;\n  }\n  \n  .summary-item:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n  \n  .label {\n    font-weight: bold;\n    color: #444;\n  }\n  \n  .value {\n    color: #333;\n    font-style: italic;\n  }\n  \n  .toggle-btn {\n    background: var(--clr-primary-9);\n    color: var(--clr-primary-1);\n    padding: 0.375rem 0.75rem;\n    font-weight: 700;\n    -webkit-transition: var(--transition);\n    transition: var(--transition);\n    font-size: 0.875rem;\n    border: 2px solid transparent;\n    cursor: pointer;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n    border-radius: var(--radius);\n\n  }\n  \n  .toggle-btn:hover {\n    text-decoration: underline;\n  } */\n\n  /* Header Styling */\n.form-header {\n  text-align: center; \n  font-size: 1.5rem; \n  color: var(--clr-primary-3); \n  margin-bottom: 1.5rem; \n}\n\n.form-header-no-align {\n  /* text-align: center;  */\n  font-size: 1.5rem; \n  color: var(--clr-grey-1); \n  margin-bottom: 1.5rem; \n}\n  /* BusinessDetailsForm Specific */\n.business-details-form {\n  max-width: 1200px; /* Expand form width */\n  margin: 0 auto;\n  padding: 2rem;\n  background-color: #f9f9f9; /* Light background */\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.business-details-form .form-sections-container {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px; /* Space between sections */\n  margin-bottom: 2rem;\n}\n.business-details-form .form-label {\n  text-align: left;\n  /* margin-bottom: 10px; */\n  color: hsl(185, 57%, 50%);\n}\n.business-contact-section,\n.business-address-section {\n  flex: 1; /* Equal space for both sections */\n  padding: 1.5rem;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); /* Subtle shadow */\n}\n\n.title-container-mid {\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.title-mid {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: var(--clr-grey-3);\n}\n\n.required {\n  color: red;\n  font-weight: bold;\n  margin-left: 0.2rem;\n}\n\n.required-two{\n  color: red;\n  font-weight: bold;\n  margin-left: 0.2rem;\n}\n\n/* Error Text */\n.error-text {\n  color: red;\n  font-size: 0.9rem;\n  margin-top: 0.25rem;\n  font-weight: bold;\n}\n\n.form-row .error-text {\n  display: block;\n}\n\n/* Buttons for BusinessDetailsForm */\n.business-details-form .form-navigation {\n  display: flex;\n  justify-content: center;\n  gap: 20px; /* Space between buttons */\n  margin-top: 20px;\n}\n\n.business-details-form .btn {\n  /* padding: 10px 20px; */\n  font-size: 1rem;\n  /* border-radius: 5px; */\n  cursor: pointer;\n}\n\n.business-details-form .btn-primary {\n  background-color: #007bff;\n  color: #fff;\n}\n\n.business-details-form .btn-secondary {\n  background-color: #6c757d;\n  color: #fff;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .business-details-form .form-sections-container {\n      flex-direction: column; /* Stack sections vertically on smaller screens */\n  }\n\n  .business-contact-section,\n  .business-address-section {\n      min-width: 100%; /* Full width for smaller screens */\n  }\n}\n\n/* \n  .business-address-section {\n    margin-bottom: 2rem;\n    padding: 1rem;\n    border: 1px solid var(--clr-accent);\n    border-radius: 8px;\n  }\n  \n  .business-contact-section {\n    margin-bottom: 2rem;\n    padding: 1rem;\n    border: 1px solid var(--clr-accent);\n    border-radius: 8px;\n  } */\n\n  /* .title-container-mid {\n    display: flex;\n    justify-content: center; \n    align-items: center; \n    margin-bottom: 1rem; \n    height: 4rem; \n  }\n  \n  .title-mid {\n    margin: 0;\n    font-size: 1.25rem; \n    font-weight: 500;\n    color: var(--clr-grey-3);\n  }\n\n   */\n  \n  .form-row .error-text {\n    display: block; \n  }\n  \n  .calculator-wrapper_price_detail {\n    /* background-color: var(--clr-primary-9); */\n    border: 1px solid var(--clr-primary-4);\n    border-radius: 0.75rem;\n    padding: 2rem;\n    margin-bottom: 2.5rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  }\n  \n  .calculator-wrapper_price_detail h3.form-header {\n    color: var(--clr-primary-6);\n    font-size: 1.4rem;\n    margin-bottom: 0.5rem;\n  }\n  \n  .calculator-note_price_detail {\n    color: var(--red-dark);\n    font-size: 0.95rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  .counter_price_detail {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1.5rem;\n  }\n  \n  .counter-btn_price_detail {\n    background-color: var(--clr-primary-5);\n    color: white;\n    font-size: 1.25rem;\n    width: 2.5rem;\n    height: 2.5rem;\n    border: none;\n    border-radius: 0.5rem;\n    margin: 0 1rem;\n    transition: background-color 0.2s ease;\n    cursor: pointer;\n  }\n  \n  .counter-btn_price_detail:hover {\n    background-color: var(--clr-primary-6);\n  }\n  \n  .counter-value_price_detail {\n    font-size: 1.5rem;\n    font-weight: bold;\n    color: var(--clr-primary-7);\n    padding: 0 0.5rem;\n  }\n  \n  .cost-breakdown_price_detail {\n    /* background-color: var(--clr-grey-7); */\n    border-radius: 0.5rem;\n    padding: 1rem 1.5rem;\n    color: var(--clr-grey-5);\n    font-size: 1rem;\n    line-height: 1.8;\n  }\n  \n  .cost-breakdown_price_detail p {\n    margin: 0.4rem 0;\n    color: var(--clr-grey-1);\n  }\n  \n  .total_price_detail {\n    font-size: 1.15rem;\n    font-weight: bold;\n    color: var(--clr-primary-7);\n    margin-top: 1rem;\n  }\n  \n  .max-practitioners-info {\n    background-color: var(--clr-primary-7);\n    padding: 1rem 1.5rem;\n    border-radius: var(--radius);\n    color: var(--clr-grey-1);\n    font-size: 1rem;\n    margin-bottom: 2rem;\n    text-align: center;\n    font-weight: 500;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n  }\n  \n  .phone-input-container {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n  \n  .phone-prefix {\n    width: 50px;\n    padding: 0.5rem;\n    text-align: center;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: #f5f5f5;\n    color: #555;\n  }\n  \n  .phone-main-input {\n    flex: 1;\n  }\n  \n  .checkbox-row-pricing {\n    margin: 1.5rem 0;\n    display: flex;\n    align-items: center;\n  }\n  \n  .checkbox-label-pricing {\n    font-weight: 350;\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    /* color: var(--clr-white); */\n  }\n  \n  .value-added-section {\n    margin-top: 2rem;\n    border-top: 1px solid var(--clr-grey-4);\n    padding-top: 1.5rem;\n  }\n  \n  .value-added-title {\n    font-size: 1.15rem;\n    font-weight: 600;\n    margin-bottom: 0.75rem;\n    /* color: var(--clr-primary-4); */\n  }\n  \n  .pricing-details-form {\n    /* max-width: 1200px;\n    width: 95%; */\n    margin: 2rem auto;\n    padding: 2rem;\n    background: #f9f9f9;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-2);\n  }\n  \n  .pricing-details-form-public {\n    /* max-width: 1200px;\n    width: 95%; */\n    margin: 1rem;\n    /* padding: 2rem; */\n    border: 3px solid var(--clr-primary-3);\n    /* background: #f9f9f9; */\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-2);\n  }\n\n  .pricing-public-main-title {\n    font-size: 2rem;\n    font-weight: 700;\n    margin-top: 1rem;\n    margin-bottom: 2rem;\n    text-align: center;\n    color: var(--clr-primary-5);\n  }\n  \n  .grid-layout-pricing {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 2rem;\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n  \n  @media (max-width: 768px) {\n    .grid-layout-pricing {\n      grid-template-columns: 1fr;\n    }\n  }\n  \n  /* Section Titles */\n  .section-title-pricing {\n    font-size: 1.4rem;\n    font-weight: 600;\n    margin-bottom: 1.2rem;\n    color: var(--clr-primary-3);\n  }\n  \n  /* Left Column */\n  .left-column-pricing {\n    padding: 1rem 1.5rem;\n    background-color: var(--clr-white);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n  }\n  \n  /* Right Column */\n  .right-column-pricing {\n    padding: 1rem 1.5rem;\n    background-color: var(--clr-white);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n  }\n  \n  /* One-Time Fee Box */\n  .platform-fee-box {\n    /* background-color: var(--clr-primary-9); */\n    border: 1px solid var(--clr-primary-4);\n    padding: 1rem 1.25rem;\n    /* margin-top: 2rem; */\n    margin-bottom: 0.25rem;\n    border-radius: 0.75rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  }\n  \n  /* .platform-fee-box h4 {\n    font-size: 1.1rem;\n    color: var(--clr-primary-3);\n    margin-bottom: 0.5rem;\n  }\n   */\n  .platform-total {\n    font-weight: 600;\n    color: var(--clr-primary-6);\n    margin-top: 0.75rem;\n  }\n  \n  /* Feature Bullet List */\n  .features-bullet-list {\n    margin-top: 2rem;\n  }\n  \n  .features-bullet-list h4 {\n    font-size: 1.1rem;\n    color: var(--clr-primary-4);\n    margin-bottom: 0.5rem;\n  }\n  \n  .features-bullet-list ul {\n    padding-left: 1.5rem;\n    list-style: disc;\n    color: var(--clr-grey-2);\n  }\n  \n  .features-bullet-list li {\n    margin-bottom: 0.4rem;\n    font-size: 0.95rem;\n    line-height: 1.6;\n  }\n  \n.input-and-addon-box,\n.features-box {\n  /* background-color: var(--clr-grey-7); */\n  border-radius: var(--radius);\n  padding: 1.25rem 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: var(--shadow-1);\n  border: 1px solid var(--clr-primary-4);\n}\n\n.features-box ul {\n  list-style-type: disc;\n  padding-left: 1.5rem;\n  color: var(--clr-grey-2);\n}\n\n.features-box li {\n  margin-bottom: 1rem;\n  font-size: 0.95rem;\n  line-height: 1.6;\n}\n\n.pricing-navigation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2rem;\n  margin-top: 2.5rem;\n  flex-wrap: wrap;\n}\n\n.feature-list {\n  list-style: none;\n  padding: 0;\n  margin-top: 1rem;\n}\n\n.feature-list li {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-size: 1rem;\n  color: var(--clr-grey-2);\n  padding: 0.1rem 0;\n}\n\n.feature-icon {\n  font-size: 1rem;\n  color: var(--clr-primary-5);\n  flex-shrink: 0;\n}\n\n.feature-group {\n  margin-bottom: 1.5rem;\n}\n\n.feature-group h5 {\n  font-size: 1.05rem;\n  color: var(--clr-primary-4);\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.boxed-section {\n  border: 1px solid var(--clr-primary-4);\n  border-radius: var(--radius);\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  /* background-color: var(--clr-grey-9); */\n}\n\n.tax-note {\n  font-size: 0.9rem;\n  margin-top: 0.25rem;\n  color: var(--clr-grey-6);\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
